import BaseRepository from '@/api/repositories/BaseRepository';

class NotificationRepository extends BaseRepository {
	get endpoint() {
		return 'api/notification';
	}

	getCount() {
		return this.get('count');
	}

	setAllToRead() {
		return this.post('read-all');
	}
}

export default new NotificationRepository();
